module.exports = __webpack_public_path__ + "i18n/fr.708a88769640d602fb453dc8c9c22c9a.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=i18n/[name].[hash].[ext]!./i18n/fr.json
// module id = 999
// module chunks = 60